var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppLayoutBase',[_c('template',{slot:"main"},[_c('AuthLoginContent')],1),_c('template',{slot:"navbar"},[_c('AppLayoutNavbar',[_c('template',{slot:"apps"},[_c('div')])],2)],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }